<template>
  <div>
    <el-card shadow="always">
      <div style="display: flex; justify-content: space-between; align-items: center; padding: 5px">
        <div style="display: flex; align-items: center">
          <el-input size="small" style="width: 250px" placeholder="搜索名称关键字" clearable v-model.trim="params.keyword" @change="getData()">
            <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
          </el-input>
          <el-button size="small" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
          <span style="margin: 0 5px; font-size: 14px">回款日期</span>
          <el-date-picker v-model="params.date_range" type="daterange" value-format="yyyy-MM-dd" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="getData()" style="width: 200px"> </el-date-picker>
        </div>
        <div style="display: flex">
          <el-button size="mini" type="primary" @click="saveDialog()" v-if="$isPerm('customer-receipt-save')">添加记录</el-button>
        </div>
      </div>
    </el-card>
    <el-table height="600" size="small" :data="tableData.list" border row-key="id" @selection-change="handleSelectionChange" class="box-card mt10">
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column prop="customer_name" label="客户" width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="amount" label="回款金额" width="150"></el-table-column>
      <el-table-column prop="receipt_date" label="回款日期" width="200"> </el-table-column>
      <el-table-column prop="employee_name" label="业务员" width="120"></el-table-column>
      <el-table-column prop="department_name" label="部门" width="120"></el-table-column>
      <el-table-column label="创建时间" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time | date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="saveDialog(scope.row)" v-if="$isPerm('customer-receipt-save')">编辑</el-button>
          <el-button size="mini" type="warning" @click="deleteData(scope.row.id)" v-if="$isPerm('customer-receipt-delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,sizes,prev, pager, next"
      :page-sizes="[15, 30, 50, 100, 300, 500]"
      :total="tableData.total"
      :page-size="tableData.page_size"
      :current-page="tableData.page"
      @current-change="pageChange"
      @size-change="pageSizeChange"
      class="box-card pd10 mt10"
    >
    </el-pagination>
    <div>
      <el-dialog :title="saveDialogTitle" :visible.sync="saveDialogShow" width="500px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
        <div style="padding: 20px">
          <el-form size="small" ref="formRef" :model="formData" :rules="rules" label-width="120px">
            <el-form-item label="客户" prop="customer_id" :error="errMsg.customer_id">
              <Customer v-model="formData.customer_id" style="width: 280px"></Customer>
            </el-form-item>
            <el-form-item label="业务员" prop="employee_id" :error="errMsg.employee_id">
              <employee-select v-model="formData.employee_id" style="width: 250px"></employee-select>
            </el-form-item>
            <el-form-item label="金额" prop="amount" :error="errMsg.amount">
              <el-input v-model="formData.amount" style="width: 280px"></el-input>
            </el-form-item>
            <el-form-item label="回款日期" prop="receipt_date" :error="errMsg.receipt_date">
              <el-date-picker v-model="formData.receipt_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 280px"> </el-date-picker>
            </el-form-item>
            <el-form-item label="备注" prop="notes" :error="errMsg.notes">
              <el-input type="textarea" :rows="4" v-model="formData.notes" maxlength="500" show-word-limit style="width: 280px"></el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top: 10px; text-align: center">
            <el-button size="small" type="primary" :loading="loading" @click="saveData()">保 存</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Customer from '@/components/customer/select.vue';
import EmployeeSelect from '@/components/employee/select';
export default {
  name: 'customerReceipt',
  components: {
    Customer,
    EmployeeSelect
  },
  created() {
    this.getData();
  },
  data() {
    return {
      saveDialogTitle: '',
      saveDialogShow: false,
      loading: false,
      tableData: {
        page: 0,
        page_count: 0,
        page_size: 0,
        total: 0,
        list: []
      },
      params: {
        page: 1,
        page_size: 15,
        keyword: '',
        date_range: []
      },
      formData: {
        id: 0,
        customer_id: '',
        employee_id: '',
        amount: '',
        receipt_date: '',
        notes: ''
      },
      rules: {
        customer_id: [{ required: true, message: '请选择客户', trigger: 'blur' }],
        amount: [{ required: true, message: '请填写金额', trigger: 'blur' }],
        receipt_date: [{ required: true, message: '请选择日期', trigger: 'blur' }]
      },
      errMsg: {},
      num: 0,
      selectedIds: []
    };
  },
  methods: {
    //新增/编辑
    saveDialog(row) {
      this.saveDialogShow = true;
      this.saveDialogTitle = '添加记录';
      this.formData = {
        id: 0,
        customer_id: '',
        amount: '',
        receipt_date: '',
        notes: ''
      };
      if (row) {
        this.saveDialogTitle = '编辑记录';
        this.formData = _.cloneDeep(row);
      }
    },
    // 保存数据
    async saveData() {
      this.$refs.formRef.validate(async vaild => {
        if (!vaild) return;
        this.setEmptyErrMsg();
        this.loading = true;
        let data = _.cloneDeep(this.formData);
        await this.$api.customerReceipt.save(data).then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.saveDialogShow = false;
            this.getData();
          } else {
            for (let k in res.data) {
              this.errMsg[k] = res.data[k];
            }
          }
        });
      });
    },
    //初始化错误信息对象
    setEmptyErrMsg() {
      this.errMsg = {};
      this.$refs.formRef.fields.map(i => {
        this.$set(this.errMsg, i.prop, '');
      });
    },
    //删除
    async deleteData(id) {
      if (this.selectedIds.length != 1 && !id) {
        this.$message.warning('请选中1条数据');
        return;
      }
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let params = {
            id: this.selectedIds[0]
          };
          if (id) {
            params.id = id;
          }
          this.loading = true;
          await this.$api.customerReceipt.delete(params).then(res => {
            this.loading = false;
            if (res.code != 200) return;
            this.$message.success(res.msg);
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 获取数据
    async getData() {
      let params = Object.assign({}, this.params);
      if (params.date_range) params.date_range = params.date_range.join(',');
      await this.$api.customerReceipt.list(params).then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
      });
    },
    //多选
    handleSelectionChange(selectedItems) {
      let list = [];
      for (const val of selectedItems) {
        if (!list.includes(val.id)) {
          list.push(val.id);
        }
      }
      this.selectedIds = list;
    },
    // 分页切换
    pageChange(page) {
      this.params.page = page;
      this.getData();
    },
    // 分页大小切换
    pageSizeChange(pageSize) {
      this.params.page_size = pageSize;
      this.getData();
    },
    //刷新
    refresh() {
      this.getData();
    }
  }
};
</script>
